import { Opacity, ShoppingCart } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BasketContext } from "../../contexts/BasketContext";
import { HtmlTooltip } from "../HtmlTooltip";
import { HeaderBadge } from "./HeaderBadge";
import './index.scss';

export const BasketBadge: React.FC = () => {
    const navigate = useNavigate();

    const basketContext = useContext(BasketContext)

    return (
        <HtmlTooltip
            placement="bottom"
            title={
                <>
                    {
                        basketContext.basket.items.length === 0 &&
                        <Typography
                            variant="caption"
                        >
                            Basket is empty
                        </Typography>
                    }
                    {basketContext.basket.items.map((item, i) => {
                        return (
                            <Typography key={i} className="basket-badge-tooltip-item">
                                <span>{item.materialGroup.title}</span>
                                <small>({item.requestedQuantity})</small>
                            </Typography>
                        )
                    })}
                </>
            }
        >
            <IconButton
                aria-label="cart"
                onClick={() => navigate("/basket")}
            >
                <HeaderBadge
                    badgeContent={basketContext.basket.items.length}
                    color="secondary"
                    sx={{ color: 'primary.main', opacity: basketContext.basket.items.length > 0 ? 1 : 0.65 }}>
                    <ShoppingCart />

                </HeaderBadge>
            </IconButton>
        </HtmlTooltip>
    );
};
